import {
  DashboardOutlined,
  FileOutlined,
  // MenuOutlined,
  LayoutOutlined,
  SettingOutlined,
  MailOutlined,
  // ProjectOutlined,
  UserOutlined,
  UserAddOutlined,
  ShoppingOutlined,
  GlobalOutlined,
  TableOutlined,
  AppstoreAddOutlined,
} from '@ant-design/icons';

import roles from './roles';

import { MenuItem } from 'common/components/Sidebar';
import { ROUTE_PATHS } from 'common/utils/constant';

const menuSidebar: MenuItem[] = [
  {
    key: 'dashboard',
    title: 'sidebar.dashboard',
    path: '/',
    icon: <DashboardOutlined />,
  },
  {
    key: 'file',
    title: 'sidebar.file',
    icon: <FileOutlined />,
    path: ROUTE_PATHS.FILE_MANAGEMENT,
    role: roles.FOLDER_VIEWALL
  },
  {
    key: 'website',
    title: 'Website',
    icon: <GlobalOutlined />,
    items: [
      {
        key: 'page_list',
        title: 'sidebar.page',
        path: ROUTE_PATHS.PAGE_MANAGEMENT,
        role: roles.PAGE_INDEX,
        childrens: [ROUTE_PATHS.PAGE_DETAIL]
      },
      {
        key: 'page_template',
        title: 'sidebar.pageTemplate',
        path: ROUTE_PATHS.PAGE_TEMPLATE_MANAGEMENT,
        role: roles.TEMPLATE_INDEX
      },
      {
        key: 'news_management',
        title: 'sidebar.news',
        path: ROUTE_PATHS.NEWS_MANAGEMENT,
        role: roles.NEWS_INDEX,
        childrens: [ROUTE_PATHS.NEWS_DETAIL]
      },
      {
        key: 'news_category',
        title: 'sidebar.newsCategory',
        path: ROUTE_PATHS.NEWS_CATEGORY_MANAGEMENT,
        role: roles.NEWS_CATE_INDEX,
        childrens: [ROUTE_PATHS.NEWS_CATEGORY_DETAIL]
      },
      // {
      //   key: 'menu',
      //   title: 'sidebar.menu',
      //   icon: <MenuOutlined />,
      //   path: ROUTE_PATHS.MENU_MANAGEMENT,
      //   role: roles.MENU_INDEX,
      //   childrens: [ROUTE_PATHS.MENU_DETAIL]
      // },
      {
        key: 'banner',
        title: 'sidebar.banner',
        icon: <LayoutOutlined />,
        path: ROUTE_PATHS.BANNER_MANAGEMENT,
        role: roles.BANNER_INDEX,
        childrens: [ROUTE_PATHS.BANNER_DETAIL]
      },
      {
        key: 'blog',
        title: 'sidebar.blog',
        path: ROUTE_PATHS.BLOG_MANAGEMENT,
        role: roles.BLOG_INDEX,
        childrens: [ROUTE_PATHS.BLOG_DETAIL]
      },
      {
        key: 'blog_category',
        title: 'sidebar.blogCategory',
        path: ROUTE_PATHS.BLOG_CATEGORY_MANAGEMENT,
        role: roles.BLOG_CATE_INDEX,
        childrens: [ROUTE_PATHS.BLOG_CATEGORY_DETAIL]
      },
      // {
      //   key: 'static_block',
      //   title: 'sidebar.staticBlocks',
      //   icon: <ProjectOutlined />,
      //   path: ROUTE_PATHS.STATIC_BLOCK_MANAGEMENT,
      //   role: roles.STATIC_BLOCK_INDEX,
      //   childrens: [ROUTE_PATHS.STATIC_BLOCK_DETAIL]
      // },
      // {
      //   key: 'faq_management',
      //   title: 'sidebar.faqs',
      //   path: ROUTE_PATHS.FAQ_MANAGEMENT,
      //   role: roles.FAQ_INDEX,
      //   childrens: [ROUTE_PATHS.FAQ_DETAIL]
      // },
      // {
      //   key: 'faq_category_management',
      //   title: 'sidebar.faqCategory',
      //   path: ROUTE_PATHS.FAQ_CATEGORY_MANAGEMENT,
      //   role: roles.FAQ_CATEGORY_INDEX,
      //   childrens: [ROUTE_PATHS.FAQ_CATEGORY_DETAIL]
      // },
      // {
      //   key: 'contact_management',
      //   title: 'sidebar.contact',
      //   path: ROUTE_PATHS.CONTACT_MANAGEMENT,
      //   role: roles.CONTACT_INDEX
      // },
      // {
      //   key: 'contact_problem',
      //   title: 'sidebar.contactProblem',
      //   path: ROUTE_PATHS.CONTACT_PROBLEM_MANAGEMENT,
      //   role: roles.CONTACT_PROBLEM_INDEX,
      //   childrens: [ROUTE_PATHS.CONTACT_PROBLEM_DETAIL]
      // },
      {
        key: 'email_template',
        title: 'sidebar.emailTemplate',
        icon: <MailOutlined />,
        path: ROUTE_PATHS.EMAIL_TEMPLATE_MANAGEMENT,
        role: roles.EMAIL_TEMPLATE_INDEX,
        childrens: [ROUTE_PATHS.EMAIL_TEMPLATE_DETAIL]
      },
      // {
      //   key: 'forms',
      //   title: 'sidebar.forms',
      //   path: ROUTE_PATHS.FORM_MANAGEMENT,
      //   role: roles.FORM_INDEX,
      //   childrens: [ROUTE_PATHS.FORM_DETAIL],
      // },
      // {
      //   key: 'submit_form',
      //   title: 'sidebar.typeFormSubmit',
      //   path: ROUTE_PATHS.SUBMIT_FORM_MANAGEMENT,
      //   role: roles.SUBMIT_FROM,
      //   childrens: [ROUTE_PATHS.SUBMIT_FORM_LIST_BY_FORM]
      // },
      {
        key: 'fe_translation',
        title: 'sidebar.feTranslations',
        path: ROUTE_PATHS.FE_TRANSLATION_MANAGEMENT,
        role: roles.FE_TRANSLATION_INDEX
      },
      {
        key: 'cms_translation',
        title: 'sidebar.cmsTranslations',
        path: ROUTE_PATHS.CMS_TRANSLATION_MANAGEMENT,
        role: roles.CMS_TRANSLATION_INDEX
      },
      // {
      //   key: 'redirect',
      //   title: 'sidebar.redirect',
      //   path: ROUTE_PATHS.REDIRECT_MANAGEMENT,
      //   role: roles.REDIRECT_INDEX
      // },
      // {
      //   key: 'config-management',
      //   title: 'sidebar.headerFooter',
      //   path: ROUTE_PATHS.SYSTEM_CONFIG_MANAGEMENT,
      //   role: roles.CONFIG_HEADER_INDEX || roles.CONFIG_FOOTER_INDEX,
      // },
      // {
      //   key: 'errors_management',
      //   title: 'sidebar.errorsManagement',
      //   path: ROUTE_PATHS.ERRORS_MANAGEMENT,
      // }
    ]
  },
  {
    key: 'client',
    title: 'sidebar.client',
    icon: <UserAddOutlined />,
    path: ROUTE_PATHS.CLIENT_MANAGEMENT,
    role: roles.CLIENT_INDEX,
    childrens: [ROUTE_PATHS.CLIENT_DETAIL]
  },
  {
    key: 'package',
    title: 'sidebar.package',
    icon: <ShoppingOutlined />,
    path: ROUTE_PATHS.PACKAGES_MANAGEMENT,
    role: roles.PACKAGE_INDEX,
    childrens: [ROUTE_PATHS.PACKAGES_DETAIL]
  },
  {
    key: 'compare_package',
    title: 'sidebar.pageComparePackage',
    icon: <TableOutlined />,
    path: ROUTE_PATHS.PAGE_COMPARE_PACKAGE,
    role: roles.PACKAGE_INDEX,
  },
  {
    key: 'addon_package',
    title: 'sidebar.add_on_package',
    icon: <AppstoreAddOutlined />,
    path: ROUTE_PATHS.ADD_ON_PACKAGE,
    role: roles.PACKAGE_INDEX,
  },
  {
    key: 'customer',
    title: 'sidebar.customer',
    icon: <UserOutlined />,
    path: ROUTE_PATHS.CUSTOMER_MANAGEMENT,
    role: roles.CUSTOMER_INDEX,
    childrens: [ROUTE_PATHS.CUSTOMER_DETAIL]
  },
  {
    key: 'system',
    title: 'sidebar.system',
    icon: <SettingOutlined />,
    items: [
      {
        key: 'system_management',
        title: 'sidebar.general',
        path: ROUTE_PATHS.SYSTEM_MANAGEMENT,
        role: roles.SYSTEM_INDEX
      },
      {
        key: 'user_management',
        title: 'sidebar.users',
        path: ROUTE_PATHS.USERS_MANAGEMENT,
        role: '*',
      },
      {
        key: 'roles',
        title: 'sidebar.roles',
        path: ROUTE_PATHS.ROLES_MANAGEMENT,
        role: '*',
      },
      {
        key: 'activity_logs',
        title: 'sidebar.activityLogs',
        path: ROUTE_PATHS.ACTIVITY_MANAGEMENT,
        role: roles.ACTIVITYLOG_INDEX,
      },
    ],
  },
  {
    key: 'knowledge_base',
    title: 'sidebar.knowledgeBase',
    icon: <FileOutlined />,
    path: ROUTE_PATHS.KNOWLEDGE_BASE_MANAGEMENT,
  }
];

export default menuSidebar;
